import { render, staticRenderFns } from "./PickUpGoods.vue?vue&type=template&id=537dc9f4&scoped=true&"
import script from "./PickUpGoods.vue?vue&type=script&lang=js&"
export * from "./PickUpGoods.vue?vue&type=script&lang=js&"
import style0 from "./PickUpGoods.vue?vue&type=style&index=0&id=537dc9f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537dc9f4",
  null
  
)

export default component.exports